import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import type { ContractStatusNotification as ContractStatusNotificationType } from "@/gql/graphql";
import { DATE_FORMAT } from "@/constants";
import DataListItemText from "@/components/app/Navigation/GlobalHeader/Notifications/Data/DataListItemText";

type NotificationProps = {
  data: Pick<
    ContractStatusNotificationType,
    "activationDate" | "contractNumber"
  >;
};

const ContractActivationReminderNotification = (props: NotificationProps) => {
  const { data } = props;
  const { contractNumber, activationDate } = data;
  const { t } = useTranslation();

  const formattedActivationDate = activationDate
    ? dayjs(activationDate).format(DATE_FORMAT.DATE)
    : undefined;

  return (
    <DataListItemText
      primary={t("notifications.activation_reminder.title", { contractNumber })}
      secondary={t("notifications.activation_reminder.description", {
        activationDate: formattedActivationDate,
      })}
    />
  );
};

export default ContractActivationReminderNotification;
